import { useContext } from 'react';
import { useSelector } from 'react-redux';
import type { GetSiteResponse } from '@plone/types';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import DefaultSummary from '@kitconcept/volto-light-theme/components/Summary/DefaultSummary';
import type { SummaryComponentType } from '@kitconcept/volto-light-theme/components/Summary/DefaultSummary';
import Card from '../../../primitives/Card/Card';
import config from '@plone/volto/registry';
import { GridContext } from '@plone/volto/components/manage/Blocks/Grid/context';

type FormState = {
  site: { data: GetSiteResponse };
};

const TeaserDefaultTemplate = (props) => {
  const site = useSelector<FormState, GetSiteResponse>(
    (state) => state.site?.data,
  );
  const hideProfileLinks = site?.['kitconcept.disable_profile_links'];
  const { data, isEditMode, isContainer } = props;
  const columns = useContext(GridContext);
  const sizes = config.blocks.blocksConfig.teaser?.getSizes?.({
    data,
    inGrid: isContainer,
    columns,
  });
  const href = data.href?.[0] || {};
  const image = data.preview_image?.[0];
  const url = data.preview_image?.[0]?.['@id'];

  const Image = config.getComponent('Image').component;
  const Summary = (config.getComponent({
    name: 'Summary',
    dependencies: [href['@type']],
  }).component || DefaultSummary) as SummaryComponentType;
  let showLink = !Summary.hideLink && !isEditMode;
  if (href['@type'] === 'Person' && hideProfileLinks !== undefined) {
    showLink = !hideProfileLinks && !isEditMode;
  }
  const { openExternalLinkInNewTab } = config.settings;
  const openLinkInNewTab =
    data.openLinkInNewTab ||
    (openExternalLinkInNewTab && !isInternalURL(href['@id']));

  // Ensures that overridden fields are used when "overwrite" is true
  // and fallbacks to empty strings if they are not provided to ensure no undefined
  // values are passed
  const localOverrides = {
    title: data.title || '',
    description: data.description || '',
    head_title: data.head_title || '',
  };

  return (
    <Card item={showLink ? href : null} openLinkInNewTab={openLinkInNewTab}>
      <Card.Image
        src={url && !image?.image_field ? url : undefined}
        item={!data.overwrite ? href : { ...href, ...localOverrides }}
        image={data.overwrite ? image : undefined}
        imageComponent={Image}
        sizes={sizes}
      />
      <Card.Summary>
        <Summary
          item={!data.overwrite ? href : { ...href, ...localOverrides }}
          hide_description={props.data?.hide_description}
        />
      </Card.Summary>
    </Card>
  );
};

export default TeaserDefaultTemplate;
